import moment, { Moment } from "moment";
import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { updateSelectedMonth } from "../data/filtersSlice";
import { RootState, useAppDispatch } from "../data/store";

export function useMonthFilter() {
  const dispatch = useAppDispatch();

  // Селекторът връща низа - нов moment обект при всяко извикване кара
  // компонента да се рисува наново при всяко действие в store-а
  const selectedMonthValue = useSelector(
    (state: RootState) => state.filters.selectedMonth
  );
  const selectedMonth = useMemo(
    () => (selectedMonthValue ? moment(selectedMonthValue) : null),
    [selectedMonthValue]
  );

  const setSelectedMonth = useCallback(
    (month: Moment | null) => {
      dispatch(
        updateSelectedMonth(
          month && month.isValid() ? month.format("YYYY-MM") : null
        )
      );
    },
    [dispatch]
  );

  return {
    selectedMonth,
    setSelectedMonth,
  };
}
